import { useEffect, useState, useContext } from "react";
import { Cable, Power, PowerOff, Copy } from "lucide-react";
import api from "../shared/services/api";
import {toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SidebarContext } from "../shared/context/SidebarContext";


export default function Webhook() {

    const { isOpen } = useContext(SidebarContext);
    const [integrations, setIntegrations] = useState([]);


    useEffect(() => { loadIntegrations(); }, []);


    const loadIntegrations = async () => {
        try {
            const response = await api.get("/integrations");
            setIntegrations(response.data);
        } catch {
            toast.error("Erro ao buscar integrações");
        }
    };

    const toggleStatus = async (integration) => {
        try {
            await api.patch(`/integrations/${integration.id}`, { status: !integration.status });
            loadIntegrations();
        } catch {
            toast.error("Erro ao atualizar status");
        }
    };

    const copyUrl = async (url) => {
        try {
            await navigator.clipboard.writeText(url);
            toast.success("URL copiada");
        } catch {
            toast.error("Falha ao copiar");
        }
    };


    return (
        <div className="min-h-screen text-ink-1 flex relative z-0">
            <div className={`transition-all duration-300 ease-out-expo ${isOpen ? "lg:ml-64" : "sm:ml-16"} w-full max-w-full mb-16 sm:mb-0`}>

                <div className="px-5 sm:px-8 pt-8 pb-12 max-w-3xl mx-auto">

                    <header className="mb-8 animate-fade-in">
                        <div className="space-y-1">
                            <span className="label-overline">Configuração</span>
                            <h1 className="display-2 flex items-center gap-3">
                                Integrações
                                <Cable className="h-7 w-7 text-brand-400" strokeWidth={2.2} />
                            </h1>
                            <p className="text-ink-3 text-sm">
                                Webhooks ativos por empresa — copie a URL e cole no painel da Hotmart.
                            </p>
                        </div>
                    </header>

                    <div className="space-y-3 animate-slide-up">
                        {integrations.map((integration) => {
                            const url = `${import.meta.env.VITE_API_URL}/webhook/${integration.company_id}`;
                            return (
                                <div key={integration.id} className="surface-card p-5 space-y-4">
                                    <div className="flex items-center justify-between gap-3">
                                        <div className="flex items-center gap-3">
                                            <img src="/hotmart.png" alt="Hotmart" className="h-8 w-8 rounded-md" />
                                            <span className="text-lg font-semibold text-ink-1">Hotmart</span>
                                        </div>
                                        <button
                                            onClick={() => toggleStatus(integration)}
                                            className={integration.status ? "btn-ghost text-danger-400 hover:!bg-danger-500/10 hover:!border-danger-500/20" : "btn-primary !py-2"}
                                        >
                                            {integration.status ? <PowerOff className="h-4 w-4" /> : <Power className="h-4 w-4" />}
                                            {integration.status ? "Desativar" : "Ativar"}
                                        </button>
                                    </div>

                                    {integration.status && (
                                        <div className="space-y-2">
                                            <p className="label-overline">Seu link de webhook</p>
                                            <div className="flex items-center gap-2 bg-surface-3 border border-white/[0.08] rounded-xl p-3">
                                                <span className="font-mono text-xs text-ink-2 break-all flex-1">{url}</span>
                                                <button
                                                    onClick={() => copyUrl(url)}
                                                    className="p-2 text-ink-4 hover:text-brand-300 hover:bg-white/5 rounded-lg transition flex-shrink-0"
                                                    title="Copiar URL"
                                                >
                                                    <Copy className="h-4 w-4" />
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>

                </div>
            </div>
        </div>
    );
}
